module.exports = __webpack_public_path__ + "static/media/yunying2.5c0ec7f1.jpg";